import { render, staticRenderFns } from "./Zjzqr.vue?vue&type=template&id=64c64df6"
import script from "./Zjzqr.vue?vue&type=script&lang=js"
export * from "./Zjzqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports